import { Content, Separator, Stack } from '@eluve/components';
import { CancelledAppointmentDisplay } from '@eluve/frontend-feature-appointment';
import { AppointmentName, EluveAdminOnly } from '@eluve/smart-blocks';

import { AppointmentFilesDrawer } from './AppointmentFilesDrawer';
import { appointmentLayoutStyles } from './appointmentLayoutStyles';
import { ReadonlyAppointmentDetails } from './components/ReadonlyAppointmentDetails';

interface CancelledAppointmentLayoutProps {
  appointmentId: string;
}

export const CancelledAppointmentLayout: React.FC<
  CancelledAppointmentLayoutProps
> = ({ appointmentId }) => {
  return (
    <>
      <ReadonlyAppointmentDetails appointmentId={appointmentId} />
      <Content padded>
        <Stack className={appointmentLayoutStyles()} fullWidth={false} gap={2}>
          <Stack
            className="p-2"
            align="stretch"
            direction="horizontal"
            justify="between"
          >
            <AppointmentName readonly />
            <EluveAdminOnly>
              <AppointmentFilesDrawer />
            </EluveAdminOnly>
          </Stack>
          <Separator className="my-2" />
          <CancelledAppointmentDisplay />
        </Stack>
      </Content>
    </>
  );
};
